export const ADMIN='Admin';
export const TECHNICIAN='Technician'
export const NONE=''

// constants of pages 
export const DASHBOARD='DASHBOARD';
export const WORKBENCH='WORKBENCH';
export const CONFIGURABLE='CONFIGURABLE';
export const AUDITLOGS='AUDITLOGS';
export const INTERNALTRACKER='INTERNALTRACKER';

// MAPPING ROUTES TO PAGE_CONSTANTS OF TECHNCIAN AND ADMIN
export const adminRouteToPageMapper = {
   "/": DASHBOARD,
   "/workbench": WORKBENCH,
   "/configurable": CONFIGURABLE,
   "/auditLogs": AUDITLOGS,
   "/internalTracker": INTERNALTRACKER
}

export const technicianRouteToPageMapper = {
    "/home": DASHBOARD,
    "/": WORKBENCH,
    "/workbench": WORKBENCH
}

// routes for admin,technician
export const adminRouteConstants = {
    [DASHBOARD]: {
        title: 'Dashboard',
        route: '/',
    },
    [WORKBENCH]: {
        title: 'Case Assignment',
        route: '/workbench'
    },
    [CONFIGURABLE]: {
        title: 'Configurable Screen',
        route: '/configurable'
    },
    [AUDITLOGS]: {
        title: 'Audit Logs',
        route: '/auditLogs'
    },
    [INTERNALTRACKER]: {
        title: 'Internal Tracker',
        route: '/internalTracker'
    }
}
export const technicianRouteConstants = {
    [DASHBOARD]: {
        title: 'Dashboard',
        route: '/home',
    },
    [WORKBENCH]: {
        title: 'My Workbench',
        route: '/workbench'
    }
}